import { INPUT_TYPES } from '../../../lib/constants';

export const errorMessages = {
    [INPUT_TYPES.TEL]: 'Please enter a valid phone number',
    [INPUT_TYPES.EMAIL]: 'Please enter a valid email',
    required: 'This field is required',
};
